// Investor parents as delivered in globalConfigs.investor_parents by
// get_global_configs_v3: accounts owning investor entities with at least one
// CLOSED fund or fund-group commitment. This is the option list for the
// Investor Performance Report's parent picker — small (the LP base) and
// cached with the rest of the global configs.
//
// Plain string ids, not .uuid(): legacy Dataverse account ids are not all
// uuid-shaped, and a picker option that fails validation would blank the
// whole globalConfigs slice.
import { z } from 'zod'
import { makeFieldKeys } from '../../core/utils/utilities.ts'

export const InvestorParentConfigModelSchema = z
  .object({
    id: z.string(),
    name: z.string()
  })
  .strict()

export const InvestorParentConfigModelFields = makeFieldKeys(InvestorParentConfigModelSchema)

export type InvestorParentConfigModel = z.infer<typeof InvestorParentConfigModelSchema>
